export const LOCALE_PREFIX = 'scenes.Gnosus.scenes.Report.components.Workspace.components.Blocks.Estates'

export const BLOCK_TYPE = {
    BASIC: 'basic',
    EXTENDED: 'extended',
}
